import { DuplicateProcessDataService } from './shared/duplicate-process.data.service';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TramiteBase } from '@app/shared';
import { Subject } from 'rxjs';
import { SelectTramiteDuplicateComponent } from '@app/shared/select-tramite-duplicate/select-tramite-duplicate.component';

@Component({
  selector: 'iw-duplicate-process',
  templateUrl: './duplicate-process.component.html',
  styleUrls: ['./duplicate-process.component.scss'],
  providers: [ DuplicateProcessDataService ]
})
export class DuplicateProcessComponent implements OnInit, OnDestroy {
  // Define cuando esta cargando
  isLoading = false;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal
  @ViewChild('template') private template: TemplateRef<any>;
  @ViewChild('tramiteOrigen') tramiteOrigen: SelectTramiteDuplicateComponent;
  @ViewChild('tramiteDestino') tramiteDestino: SelectTramiteDuplicateComponent;

  constructor(
    private modalService: BsModalService,
    private toastr: ToastrService,
    private dpds: DuplicateProcessDataService ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Abre la modal del formulario
   *
   * @memberof DuplicateProcessComponent
   */
  open() {
    this.modalRef = this.modalService.show(this.template, { class: 'modal-lg' });
  }

  /**
   * Ejecuta la duplicacion del tramite
   *
   * @param {TramiteBase} processOrigin
   * @param {TramiteBase} processDestination
   * @memberof DuplicateProcessComponent
   */
  duplicateP(processOriginGeneric: TramiteBase, processOrigin: TramiteBase, processDestination: TramiteBase ) {
    this.isLoading = true;
    if(processOriginGeneric){
      this.dpds.duplicateProcess(processOriginGeneric.id, processDestination.id, true, [], true).subscribe(res => {
        this.isLoading = false;
      });
    }else{
      this.dpds.duplicateProcess(processOrigin.id, processDestination.id, true, [], true).subscribe(res => {
        this.isLoading = false;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/duplicate-process/duplicate-process.component.ts